module.exports = __webpack_public_path__ + "static/media/ethereum.10374bc7.svg";